import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { FirebaseFunctionsService } from 'src/app/services/firebase-functions.service';

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilComponent implements OnInit {

  infosArray: any[] = [];
  userData: any = {};
  userTempsFort: any;
  userStars: any;
  activeEvents: boolean;

  constructor(private app: AppComponent, private afs: FirebaseFunctionsService ) {
    const typeUser = sessionStorage.getItem('userType');
    if (typeUser == 'administrateur') {
      this.app.navigateTo('/admin');
    }
    this.getUserData();
   }

  ngOnInit(): void {
    this.getEvents();
    setTimeout(this.app.afficherPage, 2000);
    this.reinitializeMenus();
    document.querySelectorAll('.menu_accueil').forEach( el => {
      el.classList.add('selected');
    });
  }
  async getEvents(){
    const result = (await this.afs.getActiveEvents2()).size;
    this.activeEvents = (result > 0)? true:false;
    const vl = (document.querySelector('.vl') as HTMLElement).style.display = (this.activeEvents == true)? 'flex': 'none';
  }
  getInfos(): void{
    this.afs.getInfos().subscribe( infos => {
      infos.docs.forEach(info => {
        this.infosArray.push(info.data());
      });
    });
  }
  reinitializeMenus(): void{
    const menusTabs = document.querySelectorAll('.menus_tab');
    menusTabs.forEach( tabs => {
      (tabs as HTMLElement).classList.remove('selected');
    });
  }
  getUserData(){
    const uid = sessionStorage.getItem('userId');
    if(uid!=null){
      this.userData = this.afs.getUtilisateur(uid);
      this.userData.forEach( data => {
        this.userStars = (data.medailles_count)?.toFixed(1);
        if(data.classes !== []){
          let seul = 0; let famille = 0; let enClasse = 0;
          this.afs.getActiveEvents2().then( evt => {
            this.afs.getEtoilesByEvtId(evt.docs[0].id).forEach( etoiles => {
              etoiles.docs.forEach(etoile => {
                if(etoile.data()['userId'] == uid){
                  if(etoile.data()['type'] == 1){
                    seul = seul + etoile.data()['nbrEtoiles'];
                  }else if(etoile.data()['type'] == 2){
                    famille = famille + etoile.data()['nbrEtoiles'];
                  }else{
                    enClasse = enClasse + etoile.data()['nbrEtoiles'];
                  }
                }
                this.userTempsFort = (seul + famille + enClasse)?.toFixed(1);
              });
            });
          });
        }
      });
    }else{
      this.app.navigateTo('/');
    }
  }
}
